/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CareyApprovalDecision
 */
export interface CareyApprovalDecision {
    /**
     * 
     * @type {string}
     * @memberof CareyApprovalDecision
     */
    decision: CareyApprovalDecisionDecisionEnum;
}


/**
 * @export
 */
export const CareyApprovalDecisionDecisionEnum = {
    Approve: 'approve',
    Deny: 'deny'
} as const;
export type CareyApprovalDecisionDecisionEnum = typeof CareyApprovalDecisionDecisionEnum[keyof typeof CareyApprovalDecisionDecisionEnum];


/**
 * Check if a given object implements the CareyApprovalDecision interface.
 */
export function instanceOfCareyApprovalDecision(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "decision" in value;

    return isInstance;
}

export function CareyApprovalDecisionFromJSON(json: any): CareyApprovalDecision {
    return CareyApprovalDecisionFromJSONTyped(json, false);
}

export function CareyApprovalDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CareyApprovalDecision {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'decision': json['decision'],
    };
}

export function CareyApprovalDecisionToJSON(value?: CareyApprovalDecision | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'decision': value.decision,
    };
}

